
import Experience from './Experience/Main.js'

const experience = new Experience(document.querySelector('canvas.webgl'))